import { render, staticRenderFns } from "./gif.vue?vue&type=template&id=02827282"
import script from "./gif.vue?vue&type=script&lang=js"
export * from "./gif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02827282')) {
      api.createRecord('02827282', component.options)
    } else {
      api.reload('02827282', component.options)
    }
    module.hot.accept("./gif.vue?vue&type=template&id=02827282", function () {
      api.rerender('02827282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/gif.vue"
export default component.exports